import { useState, useMemo } from 'react';
import type { RadialData } from '@/components/charts/RadialNew';
import { splitAmount } from '@/lib/utils';
import useCopilotValueStore from '@/stores/copilotValueStore';

interface UseCustomerOverviewReturn {
  assetData: RadialData[];
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
}

/**
 * CustomerOverview 组件的数据处理逻辑
 */
export function useCustomerOverview(): UseCustomerOverviewReturn {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { copilotValue3 } = useCopilotValueStore();

  const assetData = useMemo<RadialData[]>(() => {
    if (!copilotValue3 || JSON.stringify(copilotValue3) === '{}') {
      return [
        { value: 0, color: '#FF7B52', name: '权益类' },
        { value: 0, color: '#F8467B', name: '固收类' },
        { value: 0, color: '#1677FF', name: '货币类' }
      ];
    }

    const { aggressive_before, stable_before, cash_before } = copilotValue3;
    return [
      {
        value: splitAmount(aggressive_before).numInt,
        color: '#FF7B52',
        name: '权益类'
      },
      {
        value: splitAmount(stable_before).numInt,
        color: '#F8467B',
        name: '固收类'
      },
      {
        value: splitAmount(cash_before).numInt,
        color: '#1677FF',
        name: '货币类'
      }
    ];
  }, [copilotValue3]);

  return {
    assetData,
    dialogOpen,
    setDialogOpen
  };
}
